import { useCallback, useEffect, useRef, useState } from 'react';
import { ApiError } from './api';

export function useAsync<T>(fn: () => Promise<T>, deps: unknown[]) {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const fnRef = useRef(fn);
  fnRef.current = fn;
  const reload = useCallback(async () => {
    try {
      const d = await fnRef.current();
      setData(d);
      setError(null);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : String(err));
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    setLoading(true);
    void reload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return { data, error, loading, reload, setData };
}

export function useToast() {
  const [toast, setToast] = useState<{ text: string; err?: boolean } | null>(null);
  const show = useCallback((text: string, err = false) => {
    setToast({ text, err });
    setTimeout(() => setToast(null), 3200);
  }, []);
  return { toast, show };
}

export async function run<T>(p: Promise<T>, show: (t: string, err?: boolean) => void, ok?: string): Promise<T | null> {
  try {
    const r = await p;
    if (ok) show(ok);
    return r;
  } catch (err) {
    show(err instanceof Error ? err.message : String(err), true);
    return null;
  }
}
